module.exports = __webpack_public_path__ + "static/media/notifications-qs-sub.493fad9c.svg";